
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexm2uV4BCfulOhhwTtqvU1chJN39lq7jEARfA0lNwE9bAMeta } from "/var/jenkins_home/workspace/pdf_web_biz/pages/index/index.vue?macro=true";
import { default as indexxZxXa31hgckpPbGURYhJ_45icfWtU60dO1I0R4BVp5mZkMeta } from "/var/jenkins_home/workspace/pdf_web_biz/pages/pro/index.vue?macro=true";
import { default as indexWvWgy4iRzHc3XdeByvvi1446uUwAmrp_45ECKtwNmjfA4Meta } from "/var/jenkins_home/workspace/pdf_web_biz/pages/blog/index.vue?macro=true";
import { default as indexuBOUngQM60kY7AFOy0rWFFhDEX8_L7aTI9mmpcDKPfEMeta } from "/var/jenkins_home/workspace/pdf_web_biz/pages/home/index.vue?macro=true";
import { default as _91token_93tKTk6cCCvLxviE1T4GcAl_xr2YbyNJrPhJrAnwLjPPcMeta } from "/var/jenkins_home/workspace/pdf_web_biz/pages/join/[token].vue?macro=true";
import { default as indexIjtAHlwf8dD0mMk17flFRT8afiUCYZ6fDCniLM6BUEwMeta } from "/var/jenkins_home/workspace/pdf_web_biz/pages/download/index.vue?macro=true";
import { default as indexZFqTPlsnu_45HytXX_ADZv21uH0uaU3E8KOWwriXLFTJIMeta } from "/var/jenkins_home/workspace/pdf_web_biz/pages/translate/index.vue?macro=true";
import { default as ImageResult_zckTP_PxWyujMSEnla9B3CWq6q5fRkrEYpoCBiB_2gMeta } from "/var/jenkins_home/workspace/pdf_web_biz/pages/home/ImageResult.vue?macro=true";
import { default as ReadMarkdowneZppPk6b3lIhhZxqaOm8nqPYVVJEBQ__45CqQj32V41nYMeta } from "/var/jenkins_home/workspace/pdf_web_biz/pages/home/ReadMarkdown.vue?macro=true";
import { default as indexSErsWnouPxXmVf0PMpdtETkE814nebG3cbFXkvUS_45DoMeta } from "/var/jenkins_home/workspace/pdf_web_biz/pages/maintenance/index.vue?macro=true";
import { default as indexkGvt3M4YKnUSbOcdu_45yPOLyJ_l7dmrrot_45ZGHJw3BpwMeta } from "/var/jenkins_home/workspace/pdf_web_biz/pages/home/preview/index.vue?macro=true";
import { default as indexeIdxGgsoHxAF0ShED4sxNWciMTTz3UEfTj0qI_mJp6YMeta } from "/var/jenkins_home/workspace/pdf_web_biz/pages/introduction/index.vue?macro=true";
import { default as indexEOYH1BXhAD6GEfiM_45AZulULEqkGgiAdtkcrZpPmQnhkMeta } from "/var/jenkins_home/workspace/pdf_web_biz/pages/login/forget/index.vue?macro=true";
import { default as indexoc3KLydhf34kpHNgvu6ggW7vKDXulUAQB3hYnhIsaxYMeta } from "/var/jenkins_home/workspace/pdf_web_biz/pages/account/index/index.vue?macro=true";
import { default as indexLvQ6R_6hoxJCXsylVuQIw1HqRuBpxlDkE8OvIlLoC6UMeta } from "/var/jenkins_home/workspace/pdf_web_biz/pages/versionRecord/index.vue?macro=true";
import { default as indexzVXoqbtLoCDcDY_45t_45NRUydtikDULfnWpOC8__45wAg9E0Meta } from "/var/jenkins_home/workspace/pdf_web_biz/pages/browserUpgrade/index.vue?macro=true";
import { default as lazyText2sn5XAAL0MAiVN3DkMye0_9H3N2fixGJRLqicyN9RUgMeta } from "/var/jenkins_home/workspace/pdf_web_biz/pages/home/preview/lazyText.ts?macro=true";
import { default as indexdzuY6btxyYBlj2RloxFaink0_45mMgrgwciVYEDx6_45o3QMeta } from "/var/jenkins_home/workspace/pdf_web_biz/pages/home/AIProofread/index.vue?macro=true";
import { default as lazyRenderD9h5O14Bfzk3kF_45ixy3hLFfdytbJIMWhUeyrVf_45wb4YMeta } from "/var/jenkins_home/workspace/pdf_web_biz/pages/home/preview/lazyRender.ts?macro=true";
import { default as indexx6HsgGXhVWYr_45ifmTzNYMqpF3h1qiG_HWgXuj8ug9lYMeta } from "/var/jenkins_home/workspace/pdf_web_biz/pages/home/PDFTranslate/index.vue?macro=true";
import { default as _91type_93HlTEaaEYVTKshQhainSP_93F2oS7ZelutzSXvEaxhYoMeta } from "/var/jenkins_home/workspace/pdf_web_biz/pages/account/agreement/[type].vue?macro=true";
import { default as indexFuoGT_45dkBRr1qUBbx4TtZlvoawo6H5FcI0ChsHUqZk4Meta } from "/var/jenkins_home/workspace/pdf_web_biz/pages/home/PPTXTranslate/index.vue?macro=true";
import { default as index4QUlhtGSC4pXRc5ZgHz2s0ZsRWRFRLBMcdV9K_45v_45TS8Meta } from "/var/jenkins_home/workspace/pdf_web_biz/pages/home/TextTranslate/index.vue?macro=true";
import { default as indexfMKQPjJt01zSZBc9Tv1awNe4q0EMat7WaLgI7ErgIegMeta } from "/var/jenkins_home/workspace/pdf_web_biz/pages/home/WordTranslate/index.vue?macro=true";
import { default as indexn61C2nJPeuEOHbM4iEs4LLUvvxlURkwn54DduIWlo88Meta } from "/var/jenkins_home/workspace/pdf_web_biz/pages/home/ExcelTranslate/index.vue?macro=true";
import { default as indexILkupEEjZUIBNmySiIVt48K8Tt8P_5RlXy1pUJdOaY0Meta } from "/var/jenkins_home/workspace/pdf_web_biz/pages/home/ImageTranslate/index.vue?macro=true";
import { default as indexEYAmSi29LROoco77NH4RfuZB51ywcum9lFx_mCca818Meta } from "/var/jenkins_home/workspace/pdf_web_biz/pages/account/pay/payCancel/index.vue?macro=true";
import { default as indexGuimeiVcfVHoobepiAawyC3U58_j004jPG5xsSrnmwoMeta } from "/var/jenkins_home/workspace/pdf_web_biz/pages/account/pay/payResult/index.vue?macro=true";
import { default as indextPUT67Zo85RpYrRYj7U6qIt87wdsReyqF5GemUtN_455YMeta } from "/var/jenkins_home/workspace/pdf_web_biz/pages/account/pay/payStripe/index.vue?macro=true";
import { default as indexqCHmPdf9EYP8t6zv0NDnYAwAWkuLbFaf9ANvAIxncUYMeta } from "/var/jenkins_home/workspace/pdf_web_biz/pages/account/privacyAgreement/index.vue?macro=true";
import { default as component_45stub2XNm7w_45ta75Rl5zbBShuLWHxzMTUpDNOlwsiGkVewuUMeta } from "/var/jenkins_home/workspace/pdf_web_biz/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stub2XNm7w_45ta75Rl5zbBShuLWHxzMTUpDNOlwsiGkVewuU } from "/var/jenkins_home/workspace/pdf_web_biz/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    meta: indexm2uV4BCfulOhhwTtqvU1chJN39lq7jEARfA0lNwE9bAMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/index/index.vue")
  },
  {
    name: "pro___en",
    path: "/en/pro",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/pro/index.vue")
  },
  {
    name: "pro___zh",
    path: "/zh/pro",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/pro/index.vue")
  },
  {
    name: "pro___ja",
    path: "/ja/pro",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/pro/index.vue")
  },
  {
    name: "pro___zh-TW",
    path: "/zh-TW/pro",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/pro/index.vue")
  },
  {
    name: "pro___ko",
    path: "/ko/pro",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/pro/index.vue")
  },
  {
    name: "pro___hi",
    path: "/hi/pro",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/pro/index.vue")
  },
  {
    name: "pro___de",
    path: "/de/pro",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/pro/index.vue")
  },
  {
    name: "pro___ar",
    path: "/ar/pro",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/pro/index.vue")
  },
  {
    name: "pro___fr",
    path: "/fr/pro",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/pro/index.vue")
  },
  {
    name: "pro___id",
    path: "/id/pro",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/pro/index.vue")
  },
  {
    name: "pro___itb",
    path: "/itb/pro",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/pro/index.vue")
  },
  {
    name: "pro___uk",
    path: "/uk/pro",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/pro/index.vue")
  },
  {
    name: "blog___en",
    path: "/en/blog",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/blog/index.vue")
  },
  {
    name: "blog___zh",
    path: "/zh/blog",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/blog/index.vue")
  },
  {
    name: "blog___ja",
    path: "/ja/blog",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/blog/index.vue")
  },
  {
    name: "blog___zh-TW",
    path: "/zh-TW/blog",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/blog/index.vue")
  },
  {
    name: "blog___ko",
    path: "/ko/blog",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/blog/index.vue")
  },
  {
    name: "blog___hi",
    path: "/hi/blog",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/blog/index.vue")
  },
  {
    name: "blog___de",
    path: "/de/blog",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/blog/index.vue")
  },
  {
    name: "blog___ar",
    path: "/ar/blog",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/blog/index.vue")
  },
  {
    name: "blog___fr",
    path: "/fr/blog",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/blog/index.vue")
  },
  {
    name: "blog___id",
    path: "/id/blog",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/blog/index.vue")
  },
  {
    name: "blog___itb",
    path: "/itb/blog",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/blog/index.vue")
  },
  {
    name: "blog___uk",
    path: "/uk/blog",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/blog/index.vue")
  },
  {
    name: "home___en",
    path: "/en/home",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/index.vue")
  },
  {
    name: "home___zh",
    path: "/zh/home",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/index.vue")
  },
  {
    name: "home___ja",
    path: "/ja/home",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/index.vue")
  },
  {
    name: "home___zh-TW",
    path: "/zh-TW/home",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/index.vue")
  },
  {
    name: "home___ko",
    path: "/ko/home",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/index.vue")
  },
  {
    name: "home___hi",
    path: "/hi/home",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/index.vue")
  },
  {
    name: "home___de",
    path: "/de/home",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/index.vue")
  },
  {
    name: "home___ar",
    path: "/ar/home",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/index.vue")
  },
  {
    name: "home___fr",
    path: "/fr/home",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/index.vue")
  },
  {
    name: "home___id",
    path: "/id/home",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/index.vue")
  },
  {
    name: "home___itb",
    path: "/itb/home",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/index.vue")
  },
  {
    name: "home___uk",
    path: "/uk/home",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    meta: indexm2uV4BCfulOhhwTtqvU1chJN39lq7jEARfA0lNwE9bAMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/index/index.vue")
  },
  {
    name: "index___zh",
    path: "/zh",
    meta: indexm2uV4BCfulOhhwTtqvU1chJN39lq7jEARfA0lNwE9bAMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/index/index.vue")
  },
  {
    name: "index___ja",
    path: "/ja",
    meta: indexm2uV4BCfulOhhwTtqvU1chJN39lq7jEARfA0lNwE9bAMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/index/index.vue")
  },
  {
    name: "index___zh-TW",
    path: "/zh-TW",
    meta: indexm2uV4BCfulOhhwTtqvU1chJN39lq7jEARfA0lNwE9bAMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/index/index.vue")
  },
  {
    name: "index___ko",
    path: "/ko",
    meta: indexm2uV4BCfulOhhwTtqvU1chJN39lq7jEARfA0lNwE9bAMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/index/index.vue")
  },
  {
    name: "index___hi",
    path: "/hi",
    meta: indexm2uV4BCfulOhhwTtqvU1chJN39lq7jEARfA0lNwE9bAMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/index/index.vue")
  },
  {
    name: "index___de",
    path: "/de",
    meta: indexm2uV4BCfulOhhwTtqvU1chJN39lq7jEARfA0lNwE9bAMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/index/index.vue")
  },
  {
    name: "index___ar",
    path: "/ar",
    meta: indexm2uV4BCfulOhhwTtqvU1chJN39lq7jEARfA0lNwE9bAMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/index/index.vue")
  },
  {
    name: "index___fr",
    path: "/fr",
    meta: indexm2uV4BCfulOhhwTtqvU1chJN39lq7jEARfA0lNwE9bAMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/index/index.vue")
  },
  {
    name: "index___id",
    path: "/id",
    meta: indexm2uV4BCfulOhhwTtqvU1chJN39lq7jEARfA0lNwE9bAMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/index/index.vue")
  },
  {
    name: "index___itb",
    path: "/itb",
    meta: indexm2uV4BCfulOhhwTtqvU1chJN39lq7jEARfA0lNwE9bAMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/index/index.vue")
  },
  {
    name: "index___uk",
    path: "/uk",
    meta: indexm2uV4BCfulOhhwTtqvU1chJN39lq7jEARfA0lNwE9bAMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/index/index.vue")
  },
  {
    name: "join-token___en",
    path: "/en/join/:token()",
    meta: _91token_93tKTk6cCCvLxviE1T4GcAl_xr2YbyNJrPhJrAnwLjPPcMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/join/[token].vue")
  },
  {
    name: "join-token___zh",
    path: "/zh/join/:token()",
    meta: _91token_93tKTk6cCCvLxviE1T4GcAl_xr2YbyNJrPhJrAnwLjPPcMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/join/[token].vue")
  },
  {
    name: "join-token___ja",
    path: "/ja/join/:token()",
    meta: _91token_93tKTk6cCCvLxviE1T4GcAl_xr2YbyNJrPhJrAnwLjPPcMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/join/[token].vue")
  },
  {
    name: "join-token___zh-TW",
    path: "/zh-TW/join/:token()",
    meta: _91token_93tKTk6cCCvLxviE1T4GcAl_xr2YbyNJrPhJrAnwLjPPcMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/join/[token].vue")
  },
  {
    name: "join-token___ko",
    path: "/ko/join/:token()",
    meta: _91token_93tKTk6cCCvLxviE1T4GcAl_xr2YbyNJrPhJrAnwLjPPcMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/join/[token].vue")
  },
  {
    name: "join-token___hi",
    path: "/hi/join/:token()",
    meta: _91token_93tKTk6cCCvLxviE1T4GcAl_xr2YbyNJrPhJrAnwLjPPcMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/join/[token].vue")
  },
  {
    name: "join-token___de",
    path: "/de/join/:token()",
    meta: _91token_93tKTk6cCCvLxviE1T4GcAl_xr2YbyNJrPhJrAnwLjPPcMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/join/[token].vue")
  },
  {
    name: "join-token___ar",
    path: "/ar/join/:token()",
    meta: _91token_93tKTk6cCCvLxviE1T4GcAl_xr2YbyNJrPhJrAnwLjPPcMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/join/[token].vue")
  },
  {
    name: "join-token___fr",
    path: "/fr/join/:token()",
    meta: _91token_93tKTk6cCCvLxviE1T4GcAl_xr2YbyNJrPhJrAnwLjPPcMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/join/[token].vue")
  },
  {
    name: "join-token___id",
    path: "/id/join/:token()",
    meta: _91token_93tKTk6cCCvLxviE1T4GcAl_xr2YbyNJrPhJrAnwLjPPcMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/join/[token].vue")
  },
  {
    name: "join-token___itb",
    path: "/itb/join/:token()",
    meta: _91token_93tKTk6cCCvLxviE1T4GcAl_xr2YbyNJrPhJrAnwLjPPcMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/join/[token].vue")
  },
  {
    name: "join-token___uk",
    path: "/uk/join/:token()",
    meta: _91token_93tKTk6cCCvLxviE1T4GcAl_xr2YbyNJrPhJrAnwLjPPcMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/join/[token].vue")
  },
  {
    name: "download___en",
    path: "/en/download",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/download/index.vue")
  },
  {
    name: "download___zh",
    path: "/zh/download",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/download/index.vue")
  },
  {
    name: "download___ja",
    path: "/ja/download",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/download/index.vue")
  },
  {
    name: "download___zh-TW",
    path: "/zh-TW/download",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/download/index.vue")
  },
  {
    name: "download___ko",
    path: "/ko/download",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/download/index.vue")
  },
  {
    name: "download___hi",
    path: "/hi/download",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/download/index.vue")
  },
  {
    name: "download___de",
    path: "/de/download",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/download/index.vue")
  },
  {
    name: "download___ar",
    path: "/ar/download",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/download/index.vue")
  },
  {
    name: "download___fr",
    path: "/fr/download",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/download/index.vue")
  },
  {
    name: "download___id",
    path: "/id/download",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/download/index.vue")
  },
  {
    name: "download___itb",
    path: "/itb/download",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/download/index.vue")
  },
  {
    name: "download___uk",
    path: "/uk/download",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/download/index.vue")
  },
  {
    name: "translate___en",
    path: "/en/translate",
    meta: {"middleware":[]},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/translate/index.vue")
  },
  {
    name: "translate___zh",
    path: "/zh/translate",
    meta: {"middleware":[]},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/translate/index.vue")
  },
  {
    name: "translate___ja",
    path: "/ja/translate",
    meta: {"middleware":[]},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/translate/index.vue")
  },
  {
    name: "translate___zh-TW",
    path: "/zh-TW/translate",
    meta: {"middleware":[]},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/translate/index.vue")
  },
  {
    name: "translate___ko",
    path: "/ko/translate",
    meta: {"middleware":[]},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/translate/index.vue")
  },
  {
    name: "translate___hi",
    path: "/hi/translate",
    meta: {"middleware":[]},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/translate/index.vue")
  },
  {
    name: "translate___de",
    path: "/de/translate",
    meta: {"middleware":[]},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/translate/index.vue")
  },
  {
    name: "translate___ar",
    path: "/ar/translate",
    meta: {"middleware":[]},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/translate/index.vue")
  },
  {
    name: "translate___fr",
    path: "/fr/translate",
    meta: {"middleware":[]},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/translate/index.vue")
  },
  {
    name: "translate___id",
    path: "/id/translate",
    meta: {"middleware":[]},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/translate/index.vue")
  },
  {
    name: "translate___itb",
    path: "/itb/translate",
    meta: {"middleware":[]},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/translate/index.vue")
  },
  {
    name: "translate___uk",
    path: "/uk/translate",
    meta: {"middleware":[]},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/translate/index.vue")
  },
  {
    name: "home-ImageResult___en",
    path: "/en/home/ImageResult",
    meta: ImageResult_zckTP_PxWyujMSEnla9B3CWq6q5fRkrEYpoCBiB_2gMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/ImageResult.vue")
  },
  {
    name: "home-ImageResult___zh",
    path: "/zh/home/ImageResult",
    meta: ImageResult_zckTP_PxWyujMSEnla9B3CWq6q5fRkrEYpoCBiB_2gMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/ImageResult.vue")
  },
  {
    name: "home-ImageResult___ja",
    path: "/ja/home/ImageResult",
    meta: ImageResult_zckTP_PxWyujMSEnla9B3CWq6q5fRkrEYpoCBiB_2gMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/ImageResult.vue")
  },
  {
    name: "home-ImageResult___zh-TW",
    path: "/zh-TW/home/ImageResult",
    meta: ImageResult_zckTP_PxWyujMSEnla9B3CWq6q5fRkrEYpoCBiB_2gMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/ImageResult.vue")
  },
  {
    name: "home-ImageResult___ko",
    path: "/ko/home/ImageResult",
    meta: ImageResult_zckTP_PxWyujMSEnla9B3CWq6q5fRkrEYpoCBiB_2gMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/ImageResult.vue")
  },
  {
    name: "home-ImageResult___hi",
    path: "/hi/home/ImageResult",
    meta: ImageResult_zckTP_PxWyujMSEnla9B3CWq6q5fRkrEYpoCBiB_2gMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/ImageResult.vue")
  },
  {
    name: "home-ImageResult___de",
    path: "/de/home/ImageResult",
    meta: ImageResult_zckTP_PxWyujMSEnla9B3CWq6q5fRkrEYpoCBiB_2gMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/ImageResult.vue")
  },
  {
    name: "home-ImageResult___ar",
    path: "/ar/home/ImageResult",
    meta: ImageResult_zckTP_PxWyujMSEnla9B3CWq6q5fRkrEYpoCBiB_2gMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/ImageResult.vue")
  },
  {
    name: "home-ImageResult___fr",
    path: "/fr/home/ImageResult",
    meta: ImageResult_zckTP_PxWyujMSEnla9B3CWq6q5fRkrEYpoCBiB_2gMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/ImageResult.vue")
  },
  {
    name: "home-ImageResult___id",
    path: "/id/home/ImageResult",
    meta: ImageResult_zckTP_PxWyujMSEnla9B3CWq6q5fRkrEYpoCBiB_2gMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/ImageResult.vue")
  },
  {
    name: "home-ImageResult___itb",
    path: "/itb/home/ImageResult",
    meta: ImageResult_zckTP_PxWyujMSEnla9B3CWq6q5fRkrEYpoCBiB_2gMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/ImageResult.vue")
  },
  {
    name: "home-ImageResult___uk",
    path: "/uk/home/ImageResult",
    meta: ImageResult_zckTP_PxWyujMSEnla9B3CWq6q5fRkrEYpoCBiB_2gMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/ImageResult.vue")
  },
  {
    name: "home-ReadMarkdown___en",
    path: "/en/home/ReadMarkdown",
    meta: ReadMarkdowneZppPk6b3lIhhZxqaOm8nqPYVVJEBQ__45CqQj32V41nYMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/ReadMarkdown.vue")
  },
  {
    name: "home-ReadMarkdown___zh",
    path: "/zh/home/ReadMarkdown",
    meta: ReadMarkdowneZppPk6b3lIhhZxqaOm8nqPYVVJEBQ__45CqQj32V41nYMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/ReadMarkdown.vue")
  },
  {
    name: "home-ReadMarkdown___ja",
    path: "/ja/home/ReadMarkdown",
    meta: ReadMarkdowneZppPk6b3lIhhZxqaOm8nqPYVVJEBQ__45CqQj32V41nYMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/ReadMarkdown.vue")
  },
  {
    name: "home-ReadMarkdown___zh-TW",
    path: "/zh-TW/home/ReadMarkdown",
    meta: ReadMarkdowneZppPk6b3lIhhZxqaOm8nqPYVVJEBQ__45CqQj32V41nYMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/ReadMarkdown.vue")
  },
  {
    name: "home-ReadMarkdown___ko",
    path: "/ko/home/ReadMarkdown",
    meta: ReadMarkdowneZppPk6b3lIhhZxqaOm8nqPYVVJEBQ__45CqQj32V41nYMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/ReadMarkdown.vue")
  },
  {
    name: "home-ReadMarkdown___hi",
    path: "/hi/home/ReadMarkdown",
    meta: ReadMarkdowneZppPk6b3lIhhZxqaOm8nqPYVVJEBQ__45CqQj32V41nYMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/ReadMarkdown.vue")
  },
  {
    name: "home-ReadMarkdown___de",
    path: "/de/home/ReadMarkdown",
    meta: ReadMarkdowneZppPk6b3lIhhZxqaOm8nqPYVVJEBQ__45CqQj32V41nYMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/ReadMarkdown.vue")
  },
  {
    name: "home-ReadMarkdown___ar",
    path: "/ar/home/ReadMarkdown",
    meta: ReadMarkdowneZppPk6b3lIhhZxqaOm8nqPYVVJEBQ__45CqQj32V41nYMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/ReadMarkdown.vue")
  },
  {
    name: "home-ReadMarkdown___fr",
    path: "/fr/home/ReadMarkdown",
    meta: ReadMarkdowneZppPk6b3lIhhZxqaOm8nqPYVVJEBQ__45CqQj32V41nYMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/ReadMarkdown.vue")
  },
  {
    name: "home-ReadMarkdown___id",
    path: "/id/home/ReadMarkdown",
    meta: ReadMarkdowneZppPk6b3lIhhZxqaOm8nqPYVVJEBQ__45CqQj32V41nYMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/ReadMarkdown.vue")
  },
  {
    name: "home-ReadMarkdown___itb",
    path: "/itb/home/ReadMarkdown",
    meta: ReadMarkdowneZppPk6b3lIhhZxqaOm8nqPYVVJEBQ__45CqQj32V41nYMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/ReadMarkdown.vue")
  },
  {
    name: "home-ReadMarkdown___uk",
    path: "/uk/home/ReadMarkdown",
    meta: ReadMarkdowneZppPk6b3lIhhZxqaOm8nqPYVVJEBQ__45CqQj32V41nYMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/ReadMarkdown.vue")
  },
  {
    name: "maintenance___en",
    path: "/en/maintenance",
    meta: indexSErsWnouPxXmVf0PMpdtETkE814nebG3cbFXkvUS_45DoMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/maintenance/index.vue")
  },
  {
    name: "maintenance___zh",
    path: "/zh/maintenance",
    meta: indexSErsWnouPxXmVf0PMpdtETkE814nebG3cbFXkvUS_45DoMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/maintenance/index.vue")
  },
  {
    name: "maintenance___ja",
    path: "/ja/maintenance",
    meta: indexSErsWnouPxXmVf0PMpdtETkE814nebG3cbFXkvUS_45DoMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/maintenance/index.vue")
  },
  {
    name: "maintenance___zh-TW",
    path: "/zh-TW/maintenance",
    meta: indexSErsWnouPxXmVf0PMpdtETkE814nebG3cbFXkvUS_45DoMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/maintenance/index.vue")
  },
  {
    name: "maintenance___ko",
    path: "/ko/maintenance",
    meta: indexSErsWnouPxXmVf0PMpdtETkE814nebG3cbFXkvUS_45DoMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/maintenance/index.vue")
  },
  {
    name: "maintenance___hi",
    path: "/hi/maintenance",
    meta: indexSErsWnouPxXmVf0PMpdtETkE814nebG3cbFXkvUS_45DoMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/maintenance/index.vue")
  },
  {
    name: "maintenance___de",
    path: "/de/maintenance",
    meta: indexSErsWnouPxXmVf0PMpdtETkE814nebG3cbFXkvUS_45DoMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/maintenance/index.vue")
  },
  {
    name: "maintenance___ar",
    path: "/ar/maintenance",
    meta: indexSErsWnouPxXmVf0PMpdtETkE814nebG3cbFXkvUS_45DoMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/maintenance/index.vue")
  },
  {
    name: "maintenance___fr",
    path: "/fr/maintenance",
    meta: indexSErsWnouPxXmVf0PMpdtETkE814nebG3cbFXkvUS_45DoMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/maintenance/index.vue")
  },
  {
    name: "maintenance___id",
    path: "/id/maintenance",
    meta: indexSErsWnouPxXmVf0PMpdtETkE814nebG3cbFXkvUS_45DoMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/maintenance/index.vue")
  },
  {
    name: "maintenance___itb",
    path: "/itb/maintenance",
    meta: indexSErsWnouPxXmVf0PMpdtETkE814nebG3cbFXkvUS_45DoMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/maintenance/index.vue")
  },
  {
    name: "maintenance___uk",
    path: "/uk/maintenance",
    meta: indexSErsWnouPxXmVf0PMpdtETkE814nebG3cbFXkvUS_45DoMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/maintenance/index.vue")
  },
  {
    name: "home-preview___en",
    path: "/en/home/preview",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/preview/index.vue")
  },
  {
    name: "home-preview___zh",
    path: "/zh/home/preview",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/preview/index.vue")
  },
  {
    name: "home-preview___ja",
    path: "/ja/home/preview",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/preview/index.vue")
  },
  {
    name: "home-preview___zh-TW",
    path: "/zh-TW/home/preview",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/preview/index.vue")
  },
  {
    name: "home-preview___ko",
    path: "/ko/home/preview",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/preview/index.vue")
  },
  {
    name: "home-preview___hi",
    path: "/hi/home/preview",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/preview/index.vue")
  },
  {
    name: "home-preview___de",
    path: "/de/home/preview",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/preview/index.vue")
  },
  {
    name: "home-preview___ar",
    path: "/ar/home/preview",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/preview/index.vue")
  },
  {
    name: "home-preview___fr",
    path: "/fr/home/preview",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/preview/index.vue")
  },
  {
    name: "home-preview___id",
    path: "/id/home/preview",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/preview/index.vue")
  },
  {
    name: "home-preview___itb",
    path: "/itb/home/preview",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/preview/index.vue")
  },
  {
    name: "home-preview___uk",
    path: "/uk/home/preview",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/preview/index.vue")
  },
  {
    name: "introduction___en",
    path: "/en/introduction",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/introduction/index.vue")
  },
  {
    name: "introduction___zh",
    path: "/zh/introduction",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/introduction/index.vue")
  },
  {
    name: "introduction___ja",
    path: "/ja/introduction",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/introduction/index.vue")
  },
  {
    name: "introduction___zh-TW",
    path: "/zh-TW/introduction",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/introduction/index.vue")
  },
  {
    name: "introduction___ko",
    path: "/ko/introduction",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/introduction/index.vue")
  },
  {
    name: "introduction___hi",
    path: "/hi/introduction",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/introduction/index.vue")
  },
  {
    name: "introduction___de",
    path: "/de/introduction",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/introduction/index.vue")
  },
  {
    name: "introduction___ar",
    path: "/ar/introduction",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/introduction/index.vue")
  },
  {
    name: "introduction___fr",
    path: "/fr/introduction",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/introduction/index.vue")
  },
  {
    name: "introduction___id",
    path: "/id/introduction",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/introduction/index.vue")
  },
  {
    name: "introduction___itb",
    path: "/itb/introduction",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/introduction/index.vue")
  },
  {
    name: "introduction___uk",
    path: "/uk/introduction",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/introduction/index.vue")
  },
  {
    name: "login-forget___en",
    path: "/en/login/forget",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/login/forget/index.vue")
  },
  {
    name: "login-forget___zh",
    path: "/zh/login/forget",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/login/forget/index.vue")
  },
  {
    name: "login-forget___ja",
    path: "/ja/login/forget",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/login/forget/index.vue")
  },
  {
    name: "login-forget___zh-TW",
    path: "/zh-TW/login/forget",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/login/forget/index.vue")
  },
  {
    name: "login-forget___ko",
    path: "/ko/login/forget",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/login/forget/index.vue")
  },
  {
    name: "login-forget___hi",
    path: "/hi/login/forget",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/login/forget/index.vue")
  },
  {
    name: "login-forget___de",
    path: "/de/login/forget",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/login/forget/index.vue")
  },
  {
    name: "login-forget___ar",
    path: "/ar/login/forget",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/login/forget/index.vue")
  },
  {
    name: "login-forget___fr",
    path: "/fr/login/forget",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/login/forget/index.vue")
  },
  {
    name: "login-forget___id",
    path: "/id/login/forget",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/login/forget/index.vue")
  },
  {
    name: "login-forget___itb",
    path: "/itb/login/forget",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/login/forget/index.vue")
  },
  {
    name: "login-forget___uk",
    path: "/uk/login/forget",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/login/forget/index.vue")
  },
  {
    name: "account-index___en",
    path: "/en/account",
    meta: indexoc3KLydhf34kpHNgvu6ggW7vKDXulUAQB3hYnhIsaxYMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/account/index/index.vue")
  },
  {
    name: "account-index___zh",
    path: "/zh/account",
    meta: indexoc3KLydhf34kpHNgvu6ggW7vKDXulUAQB3hYnhIsaxYMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/account/index/index.vue")
  },
  {
    name: "account-index___ja",
    path: "/ja/account",
    meta: indexoc3KLydhf34kpHNgvu6ggW7vKDXulUAQB3hYnhIsaxYMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/account/index/index.vue")
  },
  {
    name: "account-index___zh-TW",
    path: "/zh-TW/account",
    meta: indexoc3KLydhf34kpHNgvu6ggW7vKDXulUAQB3hYnhIsaxYMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/account/index/index.vue")
  },
  {
    name: "account-index___ko",
    path: "/ko/account",
    meta: indexoc3KLydhf34kpHNgvu6ggW7vKDXulUAQB3hYnhIsaxYMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/account/index/index.vue")
  },
  {
    name: "account-index___hi",
    path: "/hi/account",
    meta: indexoc3KLydhf34kpHNgvu6ggW7vKDXulUAQB3hYnhIsaxYMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/account/index/index.vue")
  },
  {
    name: "account-index___de",
    path: "/de/account",
    meta: indexoc3KLydhf34kpHNgvu6ggW7vKDXulUAQB3hYnhIsaxYMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/account/index/index.vue")
  },
  {
    name: "account-index___ar",
    path: "/ar/account",
    meta: indexoc3KLydhf34kpHNgvu6ggW7vKDXulUAQB3hYnhIsaxYMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/account/index/index.vue")
  },
  {
    name: "account-index___fr",
    path: "/fr/account",
    meta: indexoc3KLydhf34kpHNgvu6ggW7vKDXulUAQB3hYnhIsaxYMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/account/index/index.vue")
  },
  {
    name: "account-index___id",
    path: "/id/account",
    meta: indexoc3KLydhf34kpHNgvu6ggW7vKDXulUAQB3hYnhIsaxYMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/account/index/index.vue")
  },
  {
    name: "account-index___itb",
    path: "/itb/account",
    meta: indexoc3KLydhf34kpHNgvu6ggW7vKDXulUAQB3hYnhIsaxYMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/account/index/index.vue")
  },
  {
    name: "account-index___uk",
    path: "/uk/account",
    meta: indexoc3KLydhf34kpHNgvu6ggW7vKDXulUAQB3hYnhIsaxYMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/account/index/index.vue")
  },
  {
    name: "versionRecord___en",
    path: "/en/versionRecord",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/versionRecord/index.vue")
  },
  {
    name: "versionRecord___zh",
    path: "/zh/versionRecord",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/versionRecord/index.vue")
  },
  {
    name: "versionRecord___ja",
    path: "/ja/versionRecord",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/versionRecord/index.vue")
  },
  {
    name: "versionRecord___zh-TW",
    path: "/zh-TW/versionRecord",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/versionRecord/index.vue")
  },
  {
    name: "versionRecord___ko",
    path: "/ko/versionRecord",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/versionRecord/index.vue")
  },
  {
    name: "versionRecord___hi",
    path: "/hi/versionRecord",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/versionRecord/index.vue")
  },
  {
    name: "versionRecord___de",
    path: "/de/versionRecord",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/versionRecord/index.vue")
  },
  {
    name: "versionRecord___ar",
    path: "/ar/versionRecord",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/versionRecord/index.vue")
  },
  {
    name: "versionRecord___fr",
    path: "/fr/versionRecord",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/versionRecord/index.vue")
  },
  {
    name: "versionRecord___id",
    path: "/id/versionRecord",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/versionRecord/index.vue")
  },
  {
    name: "versionRecord___itb",
    path: "/itb/versionRecord",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/versionRecord/index.vue")
  },
  {
    name: "versionRecord___uk",
    path: "/uk/versionRecord",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/versionRecord/index.vue")
  },
  {
    name: "browserUpgrade___en",
    path: "/en/browserUpgrade",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/browserUpgrade/index.vue")
  },
  {
    name: "browserUpgrade___zh",
    path: "/zh/browserUpgrade",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/browserUpgrade/index.vue")
  },
  {
    name: "browserUpgrade___ja",
    path: "/ja/browserUpgrade",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/browserUpgrade/index.vue")
  },
  {
    name: "browserUpgrade___zh-TW",
    path: "/zh-TW/browserUpgrade",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/browserUpgrade/index.vue")
  },
  {
    name: "browserUpgrade___ko",
    path: "/ko/browserUpgrade",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/browserUpgrade/index.vue")
  },
  {
    name: "browserUpgrade___hi",
    path: "/hi/browserUpgrade",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/browserUpgrade/index.vue")
  },
  {
    name: "browserUpgrade___de",
    path: "/de/browserUpgrade",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/browserUpgrade/index.vue")
  },
  {
    name: "browserUpgrade___ar",
    path: "/ar/browserUpgrade",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/browserUpgrade/index.vue")
  },
  {
    name: "browserUpgrade___fr",
    path: "/fr/browserUpgrade",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/browserUpgrade/index.vue")
  },
  {
    name: "browserUpgrade___id",
    path: "/id/browserUpgrade",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/browserUpgrade/index.vue")
  },
  {
    name: "browserUpgrade___itb",
    path: "/itb/browserUpgrade",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/browserUpgrade/index.vue")
  },
  {
    name: "browserUpgrade___uk",
    path: "/uk/browserUpgrade",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/browserUpgrade/index.vue")
  },
  {
    name: "home-preview-lazyText___en",
    path: "/en/home/preview/lazyText",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/preview/lazyText.ts")
  },
  {
    name: "home-preview-lazyText___zh",
    path: "/zh/home/preview/lazyText",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/preview/lazyText.ts")
  },
  {
    name: "home-preview-lazyText___ja",
    path: "/ja/home/preview/lazyText",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/preview/lazyText.ts")
  },
  {
    name: "home-preview-lazyText___zh-TW",
    path: "/zh-TW/home/preview/lazyText",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/preview/lazyText.ts")
  },
  {
    name: "home-preview-lazyText___ko",
    path: "/ko/home/preview/lazyText",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/preview/lazyText.ts")
  },
  {
    name: "home-preview-lazyText___hi",
    path: "/hi/home/preview/lazyText",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/preview/lazyText.ts")
  },
  {
    name: "home-preview-lazyText___de",
    path: "/de/home/preview/lazyText",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/preview/lazyText.ts")
  },
  {
    name: "home-preview-lazyText___ar",
    path: "/ar/home/preview/lazyText",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/preview/lazyText.ts")
  },
  {
    name: "home-preview-lazyText___fr",
    path: "/fr/home/preview/lazyText",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/preview/lazyText.ts")
  },
  {
    name: "home-preview-lazyText___id",
    path: "/id/home/preview/lazyText",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/preview/lazyText.ts")
  },
  {
    name: "home-preview-lazyText___itb",
    path: "/itb/home/preview/lazyText",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/preview/lazyText.ts")
  },
  {
    name: "home-preview-lazyText___uk",
    path: "/uk/home/preview/lazyText",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/preview/lazyText.ts")
  },
  {
    name: "home-AIProofread___en",
    path: "/en/home/AIProofread",
    meta: indexdzuY6btxyYBlj2RloxFaink0_45mMgrgwciVYEDx6_45o3QMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/AIProofread/index.vue")
  },
  {
    name: "home-AIProofread___zh",
    path: "/zh/home/AIProofread",
    meta: indexdzuY6btxyYBlj2RloxFaink0_45mMgrgwciVYEDx6_45o3QMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/AIProofread/index.vue")
  },
  {
    name: "home-AIProofread___ja",
    path: "/ja/home/AIProofread",
    meta: indexdzuY6btxyYBlj2RloxFaink0_45mMgrgwciVYEDx6_45o3QMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/AIProofread/index.vue")
  },
  {
    name: "home-AIProofread___zh-TW",
    path: "/zh-TW/home/AIProofread",
    meta: indexdzuY6btxyYBlj2RloxFaink0_45mMgrgwciVYEDx6_45o3QMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/AIProofread/index.vue")
  },
  {
    name: "home-AIProofread___ko",
    path: "/ko/home/AIProofread",
    meta: indexdzuY6btxyYBlj2RloxFaink0_45mMgrgwciVYEDx6_45o3QMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/AIProofread/index.vue")
  },
  {
    name: "home-AIProofread___hi",
    path: "/hi/home/AIProofread",
    meta: indexdzuY6btxyYBlj2RloxFaink0_45mMgrgwciVYEDx6_45o3QMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/AIProofread/index.vue")
  },
  {
    name: "home-AIProofread___de",
    path: "/de/home/AIProofread",
    meta: indexdzuY6btxyYBlj2RloxFaink0_45mMgrgwciVYEDx6_45o3QMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/AIProofread/index.vue")
  },
  {
    name: "home-AIProofread___ar",
    path: "/ar/home/AIProofread",
    meta: indexdzuY6btxyYBlj2RloxFaink0_45mMgrgwciVYEDx6_45o3QMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/AIProofread/index.vue")
  },
  {
    name: "home-AIProofread___fr",
    path: "/fr/home/AIProofread",
    meta: indexdzuY6btxyYBlj2RloxFaink0_45mMgrgwciVYEDx6_45o3QMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/AIProofread/index.vue")
  },
  {
    name: "home-AIProofread___id",
    path: "/id/home/AIProofread",
    meta: indexdzuY6btxyYBlj2RloxFaink0_45mMgrgwciVYEDx6_45o3QMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/AIProofread/index.vue")
  },
  {
    name: "home-AIProofread___itb",
    path: "/itb/home/AIProofread",
    meta: indexdzuY6btxyYBlj2RloxFaink0_45mMgrgwciVYEDx6_45o3QMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/AIProofread/index.vue")
  },
  {
    name: "home-AIProofread___uk",
    path: "/uk/home/AIProofread",
    meta: indexdzuY6btxyYBlj2RloxFaink0_45mMgrgwciVYEDx6_45o3QMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/AIProofread/index.vue")
  },
  {
    name: "home-preview-lazyRender___en",
    path: "/en/home/preview/lazyRender",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/preview/lazyRender.ts")
  },
  {
    name: "home-preview-lazyRender___zh",
    path: "/zh/home/preview/lazyRender",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/preview/lazyRender.ts")
  },
  {
    name: "home-preview-lazyRender___ja",
    path: "/ja/home/preview/lazyRender",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/preview/lazyRender.ts")
  },
  {
    name: "home-preview-lazyRender___zh-TW",
    path: "/zh-TW/home/preview/lazyRender",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/preview/lazyRender.ts")
  },
  {
    name: "home-preview-lazyRender___ko",
    path: "/ko/home/preview/lazyRender",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/preview/lazyRender.ts")
  },
  {
    name: "home-preview-lazyRender___hi",
    path: "/hi/home/preview/lazyRender",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/preview/lazyRender.ts")
  },
  {
    name: "home-preview-lazyRender___de",
    path: "/de/home/preview/lazyRender",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/preview/lazyRender.ts")
  },
  {
    name: "home-preview-lazyRender___ar",
    path: "/ar/home/preview/lazyRender",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/preview/lazyRender.ts")
  },
  {
    name: "home-preview-lazyRender___fr",
    path: "/fr/home/preview/lazyRender",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/preview/lazyRender.ts")
  },
  {
    name: "home-preview-lazyRender___id",
    path: "/id/home/preview/lazyRender",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/preview/lazyRender.ts")
  },
  {
    name: "home-preview-lazyRender___itb",
    path: "/itb/home/preview/lazyRender",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/preview/lazyRender.ts")
  },
  {
    name: "home-preview-lazyRender___uk",
    path: "/uk/home/preview/lazyRender",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/preview/lazyRender.ts")
  },
  {
    name: "home-PDFTranslate___en",
    path: "/en/home/PDFTranslate",
    meta: indexx6HsgGXhVWYr_45ifmTzNYMqpF3h1qiG_HWgXuj8ug9lYMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/PDFTranslate/index.vue")
  },
  {
    name: "home-PDFTranslate___zh",
    path: "/zh/home/PDFTranslate",
    meta: indexx6HsgGXhVWYr_45ifmTzNYMqpF3h1qiG_HWgXuj8ug9lYMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/PDFTranslate/index.vue")
  },
  {
    name: "home-PDFTranslate___ja",
    path: "/ja/home/PDFTranslate",
    meta: indexx6HsgGXhVWYr_45ifmTzNYMqpF3h1qiG_HWgXuj8ug9lYMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/PDFTranslate/index.vue")
  },
  {
    name: "home-PDFTranslate___zh-TW",
    path: "/zh-TW/home/PDFTranslate",
    meta: indexx6HsgGXhVWYr_45ifmTzNYMqpF3h1qiG_HWgXuj8ug9lYMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/PDFTranslate/index.vue")
  },
  {
    name: "home-PDFTranslate___ko",
    path: "/ko/home/PDFTranslate",
    meta: indexx6HsgGXhVWYr_45ifmTzNYMqpF3h1qiG_HWgXuj8ug9lYMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/PDFTranslate/index.vue")
  },
  {
    name: "home-PDFTranslate___hi",
    path: "/hi/home/PDFTranslate",
    meta: indexx6HsgGXhVWYr_45ifmTzNYMqpF3h1qiG_HWgXuj8ug9lYMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/PDFTranslate/index.vue")
  },
  {
    name: "home-PDFTranslate___de",
    path: "/de/home/PDFTranslate",
    meta: indexx6HsgGXhVWYr_45ifmTzNYMqpF3h1qiG_HWgXuj8ug9lYMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/PDFTranslate/index.vue")
  },
  {
    name: "home-PDFTranslate___ar",
    path: "/ar/home/PDFTranslate",
    meta: indexx6HsgGXhVWYr_45ifmTzNYMqpF3h1qiG_HWgXuj8ug9lYMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/PDFTranslate/index.vue")
  },
  {
    name: "home-PDFTranslate___fr",
    path: "/fr/home/PDFTranslate",
    meta: indexx6HsgGXhVWYr_45ifmTzNYMqpF3h1qiG_HWgXuj8ug9lYMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/PDFTranslate/index.vue")
  },
  {
    name: "home-PDFTranslate___id",
    path: "/id/home/PDFTranslate",
    meta: indexx6HsgGXhVWYr_45ifmTzNYMqpF3h1qiG_HWgXuj8ug9lYMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/PDFTranslate/index.vue")
  },
  {
    name: "home-PDFTranslate___itb",
    path: "/itb/home/PDFTranslate",
    meta: indexx6HsgGXhVWYr_45ifmTzNYMqpF3h1qiG_HWgXuj8ug9lYMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/PDFTranslate/index.vue")
  },
  {
    name: "home-PDFTranslate___uk",
    path: "/uk/home/PDFTranslate",
    meta: indexx6HsgGXhVWYr_45ifmTzNYMqpF3h1qiG_HWgXuj8ug9lYMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/PDFTranslate/index.vue")
  },
  {
    name: "account-agreement-type___en",
    path: "/en/account/agreement/:type()",
    meta: _91type_93HlTEaaEYVTKshQhainSP_93F2oS7ZelutzSXvEaxhYoMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/account/agreement/[type].vue")
  },
  {
    name: "account-agreement-type___zh",
    path: "/zh/account/agreement/:type()",
    meta: _91type_93HlTEaaEYVTKshQhainSP_93F2oS7ZelutzSXvEaxhYoMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/account/agreement/[type].vue")
  },
  {
    name: "account-agreement-type___ja",
    path: "/ja/account/agreement/:type()",
    meta: _91type_93HlTEaaEYVTKshQhainSP_93F2oS7ZelutzSXvEaxhYoMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/account/agreement/[type].vue")
  },
  {
    name: "account-agreement-type___zh-TW",
    path: "/zh-TW/account/agreement/:type()",
    meta: _91type_93HlTEaaEYVTKshQhainSP_93F2oS7ZelutzSXvEaxhYoMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/account/agreement/[type].vue")
  },
  {
    name: "account-agreement-type___ko",
    path: "/ko/account/agreement/:type()",
    meta: _91type_93HlTEaaEYVTKshQhainSP_93F2oS7ZelutzSXvEaxhYoMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/account/agreement/[type].vue")
  },
  {
    name: "account-agreement-type___hi",
    path: "/hi/account/agreement/:type()",
    meta: _91type_93HlTEaaEYVTKshQhainSP_93F2oS7ZelutzSXvEaxhYoMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/account/agreement/[type].vue")
  },
  {
    name: "account-agreement-type___de",
    path: "/de/account/agreement/:type()",
    meta: _91type_93HlTEaaEYVTKshQhainSP_93F2oS7ZelutzSXvEaxhYoMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/account/agreement/[type].vue")
  },
  {
    name: "account-agreement-type___ar",
    path: "/ar/account/agreement/:type()",
    meta: _91type_93HlTEaaEYVTKshQhainSP_93F2oS7ZelutzSXvEaxhYoMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/account/agreement/[type].vue")
  },
  {
    name: "account-agreement-type___fr",
    path: "/fr/account/agreement/:type()",
    meta: _91type_93HlTEaaEYVTKshQhainSP_93F2oS7ZelutzSXvEaxhYoMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/account/agreement/[type].vue")
  },
  {
    name: "account-agreement-type___id",
    path: "/id/account/agreement/:type()",
    meta: _91type_93HlTEaaEYVTKshQhainSP_93F2oS7ZelutzSXvEaxhYoMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/account/agreement/[type].vue")
  },
  {
    name: "account-agreement-type___itb",
    path: "/itb/account/agreement/:type()",
    meta: _91type_93HlTEaaEYVTKshQhainSP_93F2oS7ZelutzSXvEaxhYoMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/account/agreement/[type].vue")
  },
  {
    name: "account-agreement-type___uk",
    path: "/uk/account/agreement/:type()",
    meta: _91type_93HlTEaaEYVTKshQhainSP_93F2oS7ZelutzSXvEaxhYoMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/account/agreement/[type].vue")
  },
  {
    name: "home-PPTXTranslate___en",
    path: "/en/home/PPTXTranslate",
    meta: indexFuoGT_45dkBRr1qUBbx4TtZlvoawo6H5FcI0ChsHUqZk4Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/PPTXTranslate/index.vue")
  },
  {
    name: "home-PPTXTranslate___zh",
    path: "/zh/home/PPTXTranslate",
    meta: indexFuoGT_45dkBRr1qUBbx4TtZlvoawo6H5FcI0ChsHUqZk4Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/PPTXTranslate/index.vue")
  },
  {
    name: "home-PPTXTranslate___ja",
    path: "/ja/home/PPTXTranslate",
    meta: indexFuoGT_45dkBRr1qUBbx4TtZlvoawo6H5FcI0ChsHUqZk4Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/PPTXTranslate/index.vue")
  },
  {
    name: "home-PPTXTranslate___zh-TW",
    path: "/zh-TW/home/PPTXTranslate",
    meta: indexFuoGT_45dkBRr1qUBbx4TtZlvoawo6H5FcI0ChsHUqZk4Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/PPTXTranslate/index.vue")
  },
  {
    name: "home-PPTXTranslate___ko",
    path: "/ko/home/PPTXTranslate",
    meta: indexFuoGT_45dkBRr1qUBbx4TtZlvoawo6H5FcI0ChsHUqZk4Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/PPTXTranslate/index.vue")
  },
  {
    name: "home-PPTXTranslate___hi",
    path: "/hi/home/PPTXTranslate",
    meta: indexFuoGT_45dkBRr1qUBbx4TtZlvoawo6H5FcI0ChsHUqZk4Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/PPTXTranslate/index.vue")
  },
  {
    name: "home-PPTXTranslate___de",
    path: "/de/home/PPTXTranslate",
    meta: indexFuoGT_45dkBRr1qUBbx4TtZlvoawo6H5FcI0ChsHUqZk4Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/PPTXTranslate/index.vue")
  },
  {
    name: "home-PPTXTranslate___ar",
    path: "/ar/home/PPTXTranslate",
    meta: indexFuoGT_45dkBRr1qUBbx4TtZlvoawo6H5FcI0ChsHUqZk4Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/PPTXTranslate/index.vue")
  },
  {
    name: "home-PPTXTranslate___fr",
    path: "/fr/home/PPTXTranslate",
    meta: indexFuoGT_45dkBRr1qUBbx4TtZlvoawo6H5FcI0ChsHUqZk4Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/PPTXTranslate/index.vue")
  },
  {
    name: "home-PPTXTranslate___id",
    path: "/id/home/PPTXTranslate",
    meta: indexFuoGT_45dkBRr1qUBbx4TtZlvoawo6H5FcI0ChsHUqZk4Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/PPTXTranslate/index.vue")
  },
  {
    name: "home-PPTXTranslate___itb",
    path: "/itb/home/PPTXTranslate",
    meta: indexFuoGT_45dkBRr1qUBbx4TtZlvoawo6H5FcI0ChsHUqZk4Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/PPTXTranslate/index.vue")
  },
  {
    name: "home-PPTXTranslate___uk",
    path: "/uk/home/PPTXTranslate",
    meta: indexFuoGT_45dkBRr1qUBbx4TtZlvoawo6H5FcI0ChsHUqZk4Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/PPTXTranslate/index.vue")
  },
  {
    name: "home-TextTranslate___en",
    path: "/en/home/TextTranslate",
    meta: index4QUlhtGSC4pXRc5ZgHz2s0ZsRWRFRLBMcdV9K_45v_45TS8Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/TextTranslate/index.vue")
  },
  {
    name: "home-TextTranslate___zh",
    path: "/zh/home/TextTranslate",
    meta: index4QUlhtGSC4pXRc5ZgHz2s0ZsRWRFRLBMcdV9K_45v_45TS8Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/TextTranslate/index.vue")
  },
  {
    name: "home-TextTranslate___ja",
    path: "/ja/home/TextTranslate",
    meta: index4QUlhtGSC4pXRc5ZgHz2s0ZsRWRFRLBMcdV9K_45v_45TS8Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/TextTranslate/index.vue")
  },
  {
    name: "home-TextTranslate___zh-TW",
    path: "/zh-TW/home/TextTranslate",
    meta: index4QUlhtGSC4pXRc5ZgHz2s0ZsRWRFRLBMcdV9K_45v_45TS8Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/TextTranslate/index.vue")
  },
  {
    name: "home-TextTranslate___ko",
    path: "/ko/home/TextTranslate",
    meta: index4QUlhtGSC4pXRc5ZgHz2s0ZsRWRFRLBMcdV9K_45v_45TS8Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/TextTranslate/index.vue")
  },
  {
    name: "home-TextTranslate___hi",
    path: "/hi/home/TextTranslate",
    meta: index4QUlhtGSC4pXRc5ZgHz2s0ZsRWRFRLBMcdV9K_45v_45TS8Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/TextTranslate/index.vue")
  },
  {
    name: "home-TextTranslate___de",
    path: "/de/home/TextTranslate",
    meta: index4QUlhtGSC4pXRc5ZgHz2s0ZsRWRFRLBMcdV9K_45v_45TS8Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/TextTranslate/index.vue")
  },
  {
    name: "home-TextTranslate___ar",
    path: "/ar/home/TextTranslate",
    meta: index4QUlhtGSC4pXRc5ZgHz2s0ZsRWRFRLBMcdV9K_45v_45TS8Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/TextTranslate/index.vue")
  },
  {
    name: "home-TextTranslate___fr",
    path: "/fr/home/TextTranslate",
    meta: index4QUlhtGSC4pXRc5ZgHz2s0ZsRWRFRLBMcdV9K_45v_45TS8Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/TextTranslate/index.vue")
  },
  {
    name: "home-TextTranslate___id",
    path: "/id/home/TextTranslate",
    meta: index4QUlhtGSC4pXRc5ZgHz2s0ZsRWRFRLBMcdV9K_45v_45TS8Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/TextTranslate/index.vue")
  },
  {
    name: "home-TextTranslate___itb",
    path: "/itb/home/TextTranslate",
    meta: index4QUlhtGSC4pXRc5ZgHz2s0ZsRWRFRLBMcdV9K_45v_45TS8Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/TextTranslate/index.vue")
  },
  {
    name: "home-TextTranslate___uk",
    path: "/uk/home/TextTranslate",
    meta: index4QUlhtGSC4pXRc5ZgHz2s0ZsRWRFRLBMcdV9K_45v_45TS8Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/TextTranslate/index.vue")
  },
  {
    name: "home-WordTranslate___en",
    path: "/en/home/WordTranslate",
    meta: indexfMKQPjJt01zSZBc9Tv1awNe4q0EMat7WaLgI7ErgIegMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/WordTranslate/index.vue")
  },
  {
    name: "home-WordTranslate___zh",
    path: "/zh/home/WordTranslate",
    meta: indexfMKQPjJt01zSZBc9Tv1awNe4q0EMat7WaLgI7ErgIegMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/WordTranslate/index.vue")
  },
  {
    name: "home-WordTranslate___ja",
    path: "/ja/home/WordTranslate",
    meta: indexfMKQPjJt01zSZBc9Tv1awNe4q0EMat7WaLgI7ErgIegMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/WordTranslate/index.vue")
  },
  {
    name: "home-WordTranslate___zh-TW",
    path: "/zh-TW/home/WordTranslate",
    meta: indexfMKQPjJt01zSZBc9Tv1awNe4q0EMat7WaLgI7ErgIegMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/WordTranslate/index.vue")
  },
  {
    name: "home-WordTranslate___ko",
    path: "/ko/home/WordTranslate",
    meta: indexfMKQPjJt01zSZBc9Tv1awNe4q0EMat7WaLgI7ErgIegMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/WordTranslate/index.vue")
  },
  {
    name: "home-WordTranslate___hi",
    path: "/hi/home/WordTranslate",
    meta: indexfMKQPjJt01zSZBc9Tv1awNe4q0EMat7WaLgI7ErgIegMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/WordTranslate/index.vue")
  },
  {
    name: "home-WordTranslate___de",
    path: "/de/home/WordTranslate",
    meta: indexfMKQPjJt01zSZBc9Tv1awNe4q0EMat7WaLgI7ErgIegMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/WordTranslate/index.vue")
  },
  {
    name: "home-WordTranslate___ar",
    path: "/ar/home/WordTranslate",
    meta: indexfMKQPjJt01zSZBc9Tv1awNe4q0EMat7WaLgI7ErgIegMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/WordTranslate/index.vue")
  },
  {
    name: "home-WordTranslate___fr",
    path: "/fr/home/WordTranslate",
    meta: indexfMKQPjJt01zSZBc9Tv1awNe4q0EMat7WaLgI7ErgIegMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/WordTranslate/index.vue")
  },
  {
    name: "home-WordTranslate___id",
    path: "/id/home/WordTranslate",
    meta: indexfMKQPjJt01zSZBc9Tv1awNe4q0EMat7WaLgI7ErgIegMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/WordTranslate/index.vue")
  },
  {
    name: "home-WordTranslate___itb",
    path: "/itb/home/WordTranslate",
    meta: indexfMKQPjJt01zSZBc9Tv1awNe4q0EMat7WaLgI7ErgIegMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/WordTranslate/index.vue")
  },
  {
    name: "home-WordTranslate___uk",
    path: "/uk/home/WordTranslate",
    meta: indexfMKQPjJt01zSZBc9Tv1awNe4q0EMat7WaLgI7ErgIegMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/WordTranslate/index.vue")
  },
  {
    name: "home-ExcelTranslate___en",
    path: "/en/home/ExcelTranslate",
    meta: indexn61C2nJPeuEOHbM4iEs4LLUvvxlURkwn54DduIWlo88Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/ExcelTranslate/index.vue")
  },
  {
    name: "home-ExcelTranslate___zh",
    path: "/zh/home/ExcelTranslate",
    meta: indexn61C2nJPeuEOHbM4iEs4LLUvvxlURkwn54DduIWlo88Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/ExcelTranslate/index.vue")
  },
  {
    name: "home-ExcelTranslate___ja",
    path: "/ja/home/ExcelTranslate",
    meta: indexn61C2nJPeuEOHbM4iEs4LLUvvxlURkwn54DduIWlo88Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/ExcelTranslate/index.vue")
  },
  {
    name: "home-ExcelTranslate___zh-TW",
    path: "/zh-TW/home/ExcelTranslate",
    meta: indexn61C2nJPeuEOHbM4iEs4LLUvvxlURkwn54DduIWlo88Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/ExcelTranslate/index.vue")
  },
  {
    name: "home-ExcelTranslate___ko",
    path: "/ko/home/ExcelTranslate",
    meta: indexn61C2nJPeuEOHbM4iEs4LLUvvxlURkwn54DduIWlo88Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/ExcelTranslate/index.vue")
  },
  {
    name: "home-ExcelTranslate___hi",
    path: "/hi/home/ExcelTranslate",
    meta: indexn61C2nJPeuEOHbM4iEs4LLUvvxlURkwn54DduIWlo88Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/ExcelTranslate/index.vue")
  },
  {
    name: "home-ExcelTranslate___de",
    path: "/de/home/ExcelTranslate",
    meta: indexn61C2nJPeuEOHbM4iEs4LLUvvxlURkwn54DduIWlo88Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/ExcelTranslate/index.vue")
  },
  {
    name: "home-ExcelTranslate___ar",
    path: "/ar/home/ExcelTranslate",
    meta: indexn61C2nJPeuEOHbM4iEs4LLUvvxlURkwn54DduIWlo88Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/ExcelTranslate/index.vue")
  },
  {
    name: "home-ExcelTranslate___fr",
    path: "/fr/home/ExcelTranslate",
    meta: indexn61C2nJPeuEOHbM4iEs4LLUvvxlURkwn54DduIWlo88Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/ExcelTranslate/index.vue")
  },
  {
    name: "home-ExcelTranslate___id",
    path: "/id/home/ExcelTranslate",
    meta: indexn61C2nJPeuEOHbM4iEs4LLUvvxlURkwn54DduIWlo88Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/ExcelTranslate/index.vue")
  },
  {
    name: "home-ExcelTranslate___itb",
    path: "/itb/home/ExcelTranslate",
    meta: indexn61C2nJPeuEOHbM4iEs4LLUvvxlURkwn54DduIWlo88Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/ExcelTranslate/index.vue")
  },
  {
    name: "home-ExcelTranslate___uk",
    path: "/uk/home/ExcelTranslate",
    meta: indexn61C2nJPeuEOHbM4iEs4LLUvvxlURkwn54DduIWlo88Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/ExcelTranslate/index.vue")
  },
  {
    name: "home-ImageTranslate___en",
    path: "/en/home/ImageTranslate",
    meta: indexILkupEEjZUIBNmySiIVt48K8Tt8P_5RlXy1pUJdOaY0Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/ImageTranslate/index.vue")
  },
  {
    name: "home-ImageTranslate___zh",
    path: "/zh/home/ImageTranslate",
    meta: indexILkupEEjZUIBNmySiIVt48K8Tt8P_5RlXy1pUJdOaY0Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/ImageTranslate/index.vue")
  },
  {
    name: "home-ImageTranslate___ja",
    path: "/ja/home/ImageTranslate",
    meta: indexILkupEEjZUIBNmySiIVt48K8Tt8P_5RlXy1pUJdOaY0Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/ImageTranslate/index.vue")
  },
  {
    name: "home-ImageTranslate___zh-TW",
    path: "/zh-TW/home/ImageTranslate",
    meta: indexILkupEEjZUIBNmySiIVt48K8Tt8P_5RlXy1pUJdOaY0Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/ImageTranslate/index.vue")
  },
  {
    name: "home-ImageTranslate___ko",
    path: "/ko/home/ImageTranslate",
    meta: indexILkupEEjZUIBNmySiIVt48K8Tt8P_5RlXy1pUJdOaY0Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/ImageTranslate/index.vue")
  },
  {
    name: "home-ImageTranslate___hi",
    path: "/hi/home/ImageTranslate",
    meta: indexILkupEEjZUIBNmySiIVt48K8Tt8P_5RlXy1pUJdOaY0Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/ImageTranslate/index.vue")
  },
  {
    name: "home-ImageTranslate___de",
    path: "/de/home/ImageTranslate",
    meta: indexILkupEEjZUIBNmySiIVt48K8Tt8P_5RlXy1pUJdOaY0Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/ImageTranslate/index.vue")
  },
  {
    name: "home-ImageTranslate___ar",
    path: "/ar/home/ImageTranslate",
    meta: indexILkupEEjZUIBNmySiIVt48K8Tt8P_5RlXy1pUJdOaY0Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/ImageTranslate/index.vue")
  },
  {
    name: "home-ImageTranslate___fr",
    path: "/fr/home/ImageTranslate",
    meta: indexILkupEEjZUIBNmySiIVt48K8Tt8P_5RlXy1pUJdOaY0Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/ImageTranslate/index.vue")
  },
  {
    name: "home-ImageTranslate___id",
    path: "/id/home/ImageTranslate",
    meta: indexILkupEEjZUIBNmySiIVt48K8Tt8P_5RlXy1pUJdOaY0Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/ImageTranslate/index.vue")
  },
  {
    name: "home-ImageTranslate___itb",
    path: "/itb/home/ImageTranslate",
    meta: indexILkupEEjZUIBNmySiIVt48K8Tt8P_5RlXy1pUJdOaY0Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/ImageTranslate/index.vue")
  },
  {
    name: "home-ImageTranslate___uk",
    path: "/uk/home/ImageTranslate",
    meta: indexILkupEEjZUIBNmySiIVt48K8Tt8P_5RlXy1pUJdOaY0Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/home/ImageTranslate/index.vue")
  },
  {
    name: "account-pay-payCancel___en",
    path: "/en/account/pay/payCancel",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/account/pay/payCancel/index.vue")
  },
  {
    name: "account-pay-payCancel___zh",
    path: "/zh/account/pay/payCancel",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/account/pay/payCancel/index.vue")
  },
  {
    name: "account-pay-payCancel___ja",
    path: "/ja/account/pay/payCancel",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/account/pay/payCancel/index.vue")
  },
  {
    name: "account-pay-payCancel___zh-TW",
    path: "/zh-TW/account/pay/payCancel",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/account/pay/payCancel/index.vue")
  },
  {
    name: "account-pay-payCancel___ko",
    path: "/ko/account/pay/payCancel",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/account/pay/payCancel/index.vue")
  },
  {
    name: "account-pay-payCancel___hi",
    path: "/hi/account/pay/payCancel",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/account/pay/payCancel/index.vue")
  },
  {
    name: "account-pay-payCancel___de",
    path: "/de/account/pay/payCancel",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/account/pay/payCancel/index.vue")
  },
  {
    name: "account-pay-payCancel___ar",
    path: "/ar/account/pay/payCancel",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/account/pay/payCancel/index.vue")
  },
  {
    name: "account-pay-payCancel___fr",
    path: "/fr/account/pay/payCancel",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/account/pay/payCancel/index.vue")
  },
  {
    name: "account-pay-payCancel___id",
    path: "/id/account/pay/payCancel",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/account/pay/payCancel/index.vue")
  },
  {
    name: "account-pay-payCancel___itb",
    path: "/itb/account/pay/payCancel",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/account/pay/payCancel/index.vue")
  },
  {
    name: "account-pay-payCancel___uk",
    path: "/uk/account/pay/payCancel",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/account/pay/payCancel/index.vue")
  },
  {
    name: "account-pay-payResult___en",
    path: "/en/account/pay/payResult",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/account/pay/payResult/index.vue")
  },
  {
    name: "account-pay-payResult___zh",
    path: "/zh/account/pay/payResult",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/account/pay/payResult/index.vue")
  },
  {
    name: "account-pay-payResult___ja",
    path: "/ja/account/pay/payResult",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/account/pay/payResult/index.vue")
  },
  {
    name: "account-pay-payResult___zh-TW",
    path: "/zh-TW/account/pay/payResult",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/account/pay/payResult/index.vue")
  },
  {
    name: "account-pay-payResult___ko",
    path: "/ko/account/pay/payResult",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/account/pay/payResult/index.vue")
  },
  {
    name: "account-pay-payResult___hi",
    path: "/hi/account/pay/payResult",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/account/pay/payResult/index.vue")
  },
  {
    name: "account-pay-payResult___de",
    path: "/de/account/pay/payResult",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/account/pay/payResult/index.vue")
  },
  {
    name: "account-pay-payResult___ar",
    path: "/ar/account/pay/payResult",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/account/pay/payResult/index.vue")
  },
  {
    name: "account-pay-payResult___fr",
    path: "/fr/account/pay/payResult",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/account/pay/payResult/index.vue")
  },
  {
    name: "account-pay-payResult___id",
    path: "/id/account/pay/payResult",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/account/pay/payResult/index.vue")
  },
  {
    name: "account-pay-payResult___itb",
    path: "/itb/account/pay/payResult",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/account/pay/payResult/index.vue")
  },
  {
    name: "account-pay-payResult___uk",
    path: "/uk/account/pay/payResult",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/account/pay/payResult/index.vue")
  },
  {
    name: "account-pay-payStripe___en",
    path: "/en/account/pay/payStripe",
    meta: indextPUT67Zo85RpYrRYj7U6qIt87wdsReyqF5GemUtN_455YMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/account/pay/payStripe/index.vue")
  },
  {
    name: "account-pay-payStripe___zh",
    path: "/zh/account/pay/payStripe",
    meta: indextPUT67Zo85RpYrRYj7U6qIt87wdsReyqF5GemUtN_455YMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/account/pay/payStripe/index.vue")
  },
  {
    name: "account-pay-payStripe___ja",
    path: "/ja/account/pay/payStripe",
    meta: indextPUT67Zo85RpYrRYj7U6qIt87wdsReyqF5GemUtN_455YMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/account/pay/payStripe/index.vue")
  },
  {
    name: "account-pay-payStripe___zh-TW",
    path: "/zh-TW/account/pay/payStripe",
    meta: indextPUT67Zo85RpYrRYj7U6qIt87wdsReyqF5GemUtN_455YMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/account/pay/payStripe/index.vue")
  },
  {
    name: "account-pay-payStripe___ko",
    path: "/ko/account/pay/payStripe",
    meta: indextPUT67Zo85RpYrRYj7U6qIt87wdsReyqF5GemUtN_455YMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/account/pay/payStripe/index.vue")
  },
  {
    name: "account-pay-payStripe___hi",
    path: "/hi/account/pay/payStripe",
    meta: indextPUT67Zo85RpYrRYj7U6qIt87wdsReyqF5GemUtN_455YMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/account/pay/payStripe/index.vue")
  },
  {
    name: "account-pay-payStripe___de",
    path: "/de/account/pay/payStripe",
    meta: indextPUT67Zo85RpYrRYj7U6qIt87wdsReyqF5GemUtN_455YMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/account/pay/payStripe/index.vue")
  },
  {
    name: "account-pay-payStripe___ar",
    path: "/ar/account/pay/payStripe",
    meta: indextPUT67Zo85RpYrRYj7U6qIt87wdsReyqF5GemUtN_455YMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/account/pay/payStripe/index.vue")
  },
  {
    name: "account-pay-payStripe___fr",
    path: "/fr/account/pay/payStripe",
    meta: indextPUT67Zo85RpYrRYj7U6qIt87wdsReyqF5GemUtN_455YMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/account/pay/payStripe/index.vue")
  },
  {
    name: "account-pay-payStripe___id",
    path: "/id/account/pay/payStripe",
    meta: indextPUT67Zo85RpYrRYj7U6qIt87wdsReyqF5GemUtN_455YMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/account/pay/payStripe/index.vue")
  },
  {
    name: "account-pay-payStripe___itb",
    path: "/itb/account/pay/payStripe",
    meta: indextPUT67Zo85RpYrRYj7U6qIt87wdsReyqF5GemUtN_455YMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/account/pay/payStripe/index.vue")
  },
  {
    name: "account-pay-payStripe___uk",
    path: "/uk/account/pay/payStripe",
    meta: indextPUT67Zo85RpYrRYj7U6qIt87wdsReyqF5GemUtN_455YMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/account/pay/payStripe/index.vue")
  },
  {
    name: "account-privacyAgreement___en",
    path: "/en/account/privacyAgreement",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/account/privacyAgreement/index.vue")
  },
  {
    name: "account-privacyAgreement___zh",
    path: "/zh/account/privacyAgreement",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/account/privacyAgreement/index.vue")
  },
  {
    name: "account-privacyAgreement___ja",
    path: "/ja/account/privacyAgreement",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/account/privacyAgreement/index.vue")
  },
  {
    name: "account-privacyAgreement___zh-TW",
    path: "/zh-TW/account/privacyAgreement",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/account/privacyAgreement/index.vue")
  },
  {
    name: "account-privacyAgreement___ko",
    path: "/ko/account/privacyAgreement",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/account/privacyAgreement/index.vue")
  },
  {
    name: "account-privacyAgreement___hi",
    path: "/hi/account/privacyAgreement",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/account/privacyAgreement/index.vue")
  },
  {
    name: "account-privacyAgreement___de",
    path: "/de/account/privacyAgreement",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/account/privacyAgreement/index.vue")
  },
  {
    name: "account-privacyAgreement___ar",
    path: "/ar/account/privacyAgreement",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/account/privacyAgreement/index.vue")
  },
  {
    name: "account-privacyAgreement___fr",
    path: "/fr/account/privacyAgreement",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/account/privacyAgreement/index.vue")
  },
  {
    name: "account-privacyAgreement___id",
    path: "/id/account/privacyAgreement",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/account/privacyAgreement/index.vue")
  },
  {
    name: "account-privacyAgreement___itb",
    path: "/itb/account/privacyAgreement",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/account/privacyAgreement/index.vue")
  },
  {
    name: "account-privacyAgreement___uk",
    path: "/uk/account/privacyAgreement",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz/pages/account/privacyAgreement/index.vue")
  },
  {
    name: component_45stub2XNm7w_45ta75Rl5zbBShuLWHxzMTUpDNOlwsiGkVewuUMeta?.name,
    path: "/sitemap.xml",
    component: component_45stub2XNm7w_45ta75Rl5zbBShuLWHxzMTUpDNOlwsiGkVewuU
  }
]